import {TextInputBox, TextInputBoxGenerator, TextInputState} from '@gongxigames/framework/core/fragments/display/TextInput/textInputTypes';
import {Graphics} from 'pixi.js';

export function DefaultBoxGenerator(styles?: TextInputBox): TextInputBoxGenerator {
    if (styles && styles.default) {
        styles.focused = styles.focused || styles.default;
        styles.disabled = styles.disabled || styles.default;
    } else {
        const defaultStyle = {fill: 0xcccccc};

        styles = {
            default: defaultStyle,
            focused: defaultStyle,
            disabled: defaultStyle
        };
    }

    return function(w: number, h: number, state: TextInputState): Graphics {
        const style = styles && styles[state] || {fill: 0xcccccc};
        const box = new Graphics();

        box.beginFill(style.fill);

        if (style.stroke) {
            box.lineStyle(
                style.stroke.width || 1,
                style.stroke.color || 0,
                style.stroke.alpha || 1
            );
        }

        if (style.rounded) {
            box.drawRoundedRect(0, 0, w, h, style.rounded);
        } else {
            box.drawRect(0, 0, w, h);
        }

        box.endFill();
        box.closePath();

        return box;
    };
}
